module.exports = __webpack_public_path__ + "img/1537848211.73d65c06.jpg";